const manageusers_column:any =[
    // {
    //     id:1,
    //     name:"Employee"
    // },
    {
        id:1,
        name:"Customer ID"
    },
    {
        id:2,
        name:"Email"
    },
    
    {
        id:3,
        name:"Client Name"
    },
    {
        id:4,
        name:"Status"
    },
   
    {
        id:5,
        name:"User Role"
    },
    {
        id:6,
        name:"Action"
    }
]

const manageclients_column:any =[
    {
        id:1,
        name:"Client Name"
    },
    {
        id:2,
        name:"Logo"
    },
    // {
    //     id:3,
    //     name:"No of Sites"
    // },
    {
        id:3,
        name:"Status"
    },
    // {
    //     id:4,
    //     name:"Created Date"
    // },
    {
        id:4,
        name:"Action"
    }
]
const managesites_column:any =[
    {
        id:1,
        name:"Site Name"
    },
    {
        id:2,
        name:"Site Address"
    },
    {
        id:3,
        name:"Status"
    },
    {
        id:4,
        name:"Latitude"
    },
    {
        id:5,
        name:"Longitude"
    },
    {
        id:6,
        name:"Client Name"
    },
    {
        id:7,
        name:"Action"
    }
]
const sitedrawing_column:any =[
    {
        id:1,
        name:"Site Name"
    },
    {
        id:2,
        name:"Category Name"
    },
    {
        id:3,
        name:"Title"
    },
    {
        id:4,
        name:"Image Path"
    },
    {
        id:5,
        name:"File Upload"
    },
    {
        id:6,
        name:"Action"
    }
]
const sitechangerequest_column:any =[
    {
        id:1,    
        name:"Site Name"
    },
    {
        id:2,    
        name:"Client Name"
    },
    {
        id:3,
        name:"Request Date"
    },
    {
        id:4,
        name:"Applicant Name"
    },
    {
        id:5,
        name:"Applicant Email"
    },
    // {
    //     id:6,
    //     name:"Change Type"
    // },
    {
        id:6,
        name:"Uploaded File"
    },
    {
        id:7,
        name:"Updated Drawing"
    },
    {
        id:8,
        name:"Commissioning Certificate"
    },
    {
        id:9,
        name:"Manufacturer Literature"
    },
    {
        id:10,
        name:"Approval Declaration"
    },
    {
        id:11,
        name:"Comments"
    },
]
const drawingDetailColumns:any =[
    {
        id:1,
        name:"Title"
    },
    {
        id:2,
        name:"FileName"
    },
    {
        id:3,
        name:"Action"
    }
]

export {
    manageusers_column,
    manageclients_column,
    managesites_column,
    sitedrawing_column,
    sitechangerequest_column,
    drawingDetailColumns
}